<template>
    <div class="notification-list-view" ref="notificationListView" :class="{ popup: !groupByDate }">
        <a-spin :spinning="loading">
            <div class="empty-notifications" v-if="!Object.keys(groups).length">
                <template v-if="minimized">
                    <div class="material-icons notification-shake">notifications_active</div>
                    <div class="empty-message">{{ $t('notification.noNotificationTitle1') }}</div>
                    <SupsisButton :ghost="true" :small="true" @click="redirectNotificationSettings"
                        >{{ $t('search.allNotificationSettings') }}</SupsisButton
                    >
                </template>
                <template v-else>
                    <div class="material-icons notification-shake">notifications_active</div>
                    <div class="empty-message-title">{{ $t('notification.noNotificationTitle2') }}</div>
                    <div class="empty-message">
                        {{ $t('notification.noNotificationDesc2') }}
                    </div>
                    <SupsisButton :ghost="true" :small="true" @click="redirectNotificationSettings"
                        >Adjust now</SupsisButton
                    >
                </template>
            </div>
            <div class="groups">
                <div class="group" :key="date" v-for="date of Object.keys(groups)">
                    <div class="date" v-if="groupByDate">{{ $moment(date, "YYYY-MM-DD").format("LL") }}</div>
                    <div class="items">
                        <NotificationCard
                            :notification="notification"
                            @markRead="markRead"
                            @markUnread="markUnread"
                            :key="notification._id"
                            onCardClick="{onCardClick}"
                            v-for="notification of groups[date]"
                        />
                    </div>
                </div>
            </div>
        </a-spin>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import NotificationCard from "./NotificationCard.vue";
import SupsisButton from "../Settings/components/SupsisButton.vue";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

export default Vue.extend({
    name: "NotificationListView",
    components: { NotificationCard, SupsisButton },
    props: {
        notifications: {
            type: Array,
            default: () => [],
        },
        groupByDate: {
            type: Boolean,
            default: false,
        },
        minimized: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        listeners: [],
    }),
    computed: {
        groups() {
            const groups = {};
            _.orderBy(this.notifications, ["createdAt"], ["desc"]).forEach((notification) => {
                const date = this.groupByDate
                    ? moment(notification.createdAt).format("YYYY-MM-DD")
                    : moment().format("YYYY-MM-DD HH:mm");
                if (!groups[date]) {
                    groups[date] = [];
                }
                groups[date].push(notification);
            });
            console.log("groups", groups);
            return groups;
        },
    },
    methods: {
        redirectNotificationSettings() {
            this.$router.push("/settings/notifications");
        },
        markRead(nId) {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_UPDATED, {
                id: nId,
                seen: true,
            });
        },
        markUnread(nId) {
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.NOTIFICATION_UPDATED, {
                id: nId,
                seen: false,
            });
        },
    },
    mounted() {
        const notificationListView = this.$refs.notificationListView;
        const listener = (e) => {
            const scrollHeight = notificationListView.offsetHeight + notificationListView.scrollTop;
            console.log("scrol", { scrollHeight, x: notificationListView.scrollHeight });
            if (scrollHeight + 0.5 >= notificationListView.scrollHeight) {
                this.$emit("load-more");
            }
        };
        this.listeners.push(() => notificationListView?.removeEventListener("scroll", listener));
        notificationListView?.addEventListener("scroll", listener);
    },
    beforeDestroy() {
        this.listeners.map((fn) => fn());
    },
});
</script>

<style lang="scss">
.notification-list-view {
    height: 100%;
    overflow: auto;
    .empty-notifications {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 20px 0px;
        gap: 10px;
        user-select: none;
        .empty-message-title {
            font-weight: bold;
            font-size: 20px;
        }
        .empty-message {
            font-size: 14px;
            font-weight: 400;
        }
        .notification-shake {
            font-weight: bold;
            font-size: 48px;
        }
    }
    .groups {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .group {
            .date {
                position: relative;
                display: inline;
                &:after {
                    position: absolute;
                    left: 50%;
                    bottom: -15px;
                    height: 12px;
                    width: 1px;
                    content: "";
                    background: var(--color-border-default);
                }
            }

            .items {
                display: flex;
                flex-direction: column;
                border: 1px solid var(--color-border-default);
                border-radius: 4px;

                .notification-card:last-child {
                    border-bottom: none;
                }

                .notification-card {
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid var(--color-border-default);
                    background-color: var(--color-bg-neutral-low-default);
                    padding: 20px;
                    border-radius: 4px 4px 0 0;
                    cursor: pointer;

                    .activity-card {
                        border-bottom: none !important;
                    }

                    &.seen {
                        background: var(--color-bg-default);
                    }

                    .tag {
                        background-image: var(--color-bg-default);
                        border: 1px solid var(--color-border-default);
                        line-height: 20px;
                        padding: 0 8px;
                        border-radius: 4px;
                        cursor: inherit;
                        display: inline-block;
                        color: var(--color-text-default);
                        font-size: 14px;
                        font-weight: 600;
                        position: relative;
                        margin-left: 5px;
                    }

                    .left {
                        display: flex;
                        gap: 10px;
                        align-items: center;

                        .avatar-wrapper {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            position: relative;

                            .icon {
                                display: flex;
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                position: absolute;
                                align-content: center;
                                align-items: center;
                                justify-content: center;

                                right: -8px;
                                bottom: -8px;
                                background-color: var(--color-bg-default);
                                color: var(--color-icon-default);

                                .MuiSvgIcon-root {
                                    color: var(--color-icon-default);
                                    width: 18px;
                                    height: 18px;
                                }
                            }
                        }
                    }

                    .right {
                        display: flex;
                        gap: 5px;
                        align-items: center;
                        justify-content: center;

                        .read-input {
                        }
                    }
                }
            }
        }
    }

    &.popup {
        max-height: calc(85vh - 90px);
        overflow: auto;
        .items {
            border: none !important;
        }

        .notification-card {
            padding: 10px !important;

            .notification-content {
                line-height: 20px;
            }
        }
    }
}
</style>
